import {
  ObjectId,
  Party,
  PopulatedVotingSession,
  PopulatePartyOpinion,
  Stored,
  VotingSession,
} from "../types";
import ApiModule from "./base";

export type PartyWithMatchScore = { party: Stored<Party>; score: number };

export default class SessionsModule extends ApiModule {
  constructor(baseURL: string) {
    super(baseURL, "sessions");
  }

  /**
   * Fetch all session for the current user
   *
   * This route only works if the user is signed in
   */
  async index(): Promise<Array<Stored<VotingSession>>> {
    const request = new Request(this.url, {
      method: "GET",
      headers: this._defaultHeaders(),
    });
    return await this._resolve(request);
  }

  async create(gameTemplateId: ObjectId): Promise<Stored<VotingSession>> {
    const request = new Request(this.url, {
      method: "POST",
      headers: this._defaultHeaders(),
      body: JSON.stringify({ gameTemplateId }),
    });
    return await this._resolve(request);
  }

  async participants(code: string): Promise<number> {
    const request = new Request(`${this.url}/${code}/participants`, {
      method: "GET",
      headers: this._defaultHeaders(),
    });
    return await this._resolve(request);
  }

  async read(code: string): Promise<PopulatedVotingSession> {
    const request = new Request(`${this.url}/${code}`, {
      method: "GET",
      headers: this._defaultHeaders(),
    });
    return await this._resolve(request);
  }

  async update(
    code: string,
    session: Partial<VotingSession>,
  ): Promise<boolean> {
    const request = new Request(`${this.url}/${code}`, {
      method: "PATCH",
      headers: this._defaultHeaders(),
      body: JSON.stringify({ session }),
    });
    return await this._resolve(request);
  }

  async archive(code: string): Promise<boolean> {
    const request = new Request(`${this.url}/${code}/archive`, {
      method: "POST",
      headers: this._defaultHeaders(),
    });
    return await this._resolve(request);
  }

  async results(code: string): Promise<Array<PartyWithMatchScore>> {
    const request = new Request(`${this.url}/${code}/results`, {
      method: "GET",
      headers: this._defaultHeaders(),
    });
    return await this._resolve(request);
  }

  async parties(code: string): Promise<Array<Stored<Party>>> {
    const request = new Request(`${this.url}/${code}/parties`, {
      method: "GET",
      headers: this._defaultHeaders(),
    });
    return await this._resolve(request);
  }

  async partyOpinions(
    code: string,
    statementId: ObjectId,
  ): Promise<Array<PopulatePartyOpinion>> {
    const request = new Request(
      `${this.url}/${code}/parties?statementId=${statementId}`,
      {
        method: "GET",
        headers: this._defaultHeaders(),
      },
    );
    return await this._resolve(request);
  }
}
